import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { WindowRefService } from '../window/window.service';

@Injectable()
export class AuthGuardService  {
  window: any;
  constructor(
    public authService: AuthService,
    private windowRef: WindowRefService
  ) {
    this.window = this.windowRef.nativeWindow;
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.window.location.pathname?.match("/logout")) {
      return this.authService.getProfileData().pipe(
        tap(allowed => {
          console.log('User authenticated');
        })
      );
    }
  }
}

